/**
 * API konfigürasyon dosyası
 * Environment variable'lar ve sabit değerler
 */

// API base URL'i - Environment variable'dan al, yoksa default kullan
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api';

// API timeout süresi (ms)
export const API_TIMEOUT = Number.parseInt(import.meta.env.VITE_API_TIMEOUT || '30000');

// Retry ayarları
export const API_RETRY_COUNT = 3;
export const API_RETRY_DELAY = 1000; // ms

// Auth ayarları
export const AUTH_CONFIG = {
  TOKEN_REFRESH_THRESHOLD: 5 * 60 * 1000, // 5 dakika (ms)
  STORAGE_KEYS: {
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    USER_DATA: 'user_data',
    TOKEN_EXPIRES_AT: '0'

  }
} as const;

// HTTP status kodları
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202, // 👈 Eksik
  NO_CONTENT: 204,
  MOVED_PERMANENTLY: 301, // 👈 Eksik
  FOUND: 302, // 👈 Eksik
  NOT_MODIFIED: 304, // 👈 Eksik
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405, // 👈 Eksik
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422, // 👈 Eksik
  TOO_MANY_REQUESTS: 429, // 👈 Eksik
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501, // 👈 Eksik
  BAD_GATEWAY: 502, // 👈 Eksik
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504 // 👈 Eksik
} as const;

// API response formatı
export const API_RESPONSE_FORMAT = {
  SUCCESS: 'success',
  ERROR: 'error'
} as const;

// Logging seviyesi
export type LogLevel = 'debug' | 'info' | 'warn' | 'error';
export const LOG_LEVEL: LogLevel = import.meta.env.VITE_API_LOG_LEVEL as LogLevel || 'info';

// Feature flag'ler
export const FEATURE_FLAGS = {
  ENABLE_REQUEST_LOGGING: import.meta.env.VITE_ENABLE_API_LOGGING === 'true',
  ENABLE_RESPONSE_LOGGING: import.meta.env.VITE_ENABLE_RESPONSE_LOGGING === 'true',
  ENABLE_ERROR_REPORTING: import.meta.env.VITE_ENABLE_ERROR_REPORTING === 'true'
} as const;

// API versiyonu
export const API_VERSION = 'v1';

// Cache ayarları
export const CACHE_CONFIG = {
  DEFAULT_TTL: 5 * 60 * 1000, // 5 dakika
  MAX_CACHE_SIZE: 100
} as const;

// Export tüm konfigürasyon
export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  TIMEOUT: API_TIMEOUT,
  RETRY: {
    COUNT: API_RETRY_COUNT,
    DELAY: API_RETRY_DELAY
  },
  AUTH: AUTH_CONFIG,
  HTTP_STATUS,
  RESPONSE_FORMAT: API_RESPONSE_FORMAT,
  LOG_LEVEL,
  FEATURE_FLAGS,
  VERSION: API_VERSION,
  CACHE: CACHE_CONFIG
} as const;

// Type safety için
export type ApiConfig = typeof API_CONFIG;
export type ApiFeatureFlags = typeof FEATURE_FLAGS;
export type AuthConfig = typeof AUTH_CONFIG;